import React from "react";
import { FaGithub, FaLinkedin, FaEnvelope, FaHeart } from "react-icons/fa";
import { SOCIAL_LINKS } from "./Footer.constants";

const Footer: React.FC = () => {
  const getSocialIcon = (label: string) => {
    switch (label) {
      case "GitHub":
        return <FaGithub className="text-xl" />;
      case "LinkedIn":
        return <FaLinkedin className="text-xl" />;
      case "Email":
        return <FaEnvelope className="text-xl" />;
      default:
        return null;
    }
  };

  return (
    <footer className="py-8 px-6 border-t border-slate-700/50">
      <div className="max-w-4xl mx-auto text-center text-slate-400">
        <div className="flex justify-center gap-6 mb-4">
          {SOCIAL_LINKS.map((link) => (
            <a
              key={link.label}
              href={link.href}
              target={link.label !== "Email" ? "_blank" : undefined}
              rel={link.label !== "Email" ? "noopener noreferrer" : undefined}
              className="hover:text-white transition-colors"
            >
              {getSocialIcon(link.label)}
            </a>
          ))}
        </div>
        <p>
          &copy; {new Date().getFullYear()} Dmytro Voloshyn. All rights
          reserved.
        </p>
        <p className="text-sm mt-2">
          Built with <FaHeart className="inline text-red-500" /> using React,
          TypeScript & Framer Motion
        </p>
      </div>
    </footer>
  );
};

export default Footer;
